import { makeStyles, shorthands } from "@fluentui/react-components";

const novataNavyDark = "#00344D";
const novataLime = "#D8E94B";
const novataLimeHover = "#C7D93C";
const poppins = `'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

export const useOrganizationStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    padding: "0 16px 16px 16px",
    boxSizing: "border-box",
    fontFamily: poppins,
  },
  card: {
    width: "100%",
    maxWidth: "480px",
    backgroundColor: "#ffffff",
    ...shorthands.borderRadius("12px"),
    ...shorthands.border("1px", "solid", "#E5EBEE"),
    boxShadow: "0 1px 2px rgba(2, 52, 77, 0.04)",
    display: "flex",
    flexDirection: "column",
    overflow: "visible",
    boxSizing: "border-box",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    padding: "24px 24px 16px 24px",
  },
  heading: {
    fontFamily: poppins,
    fontSize: "20px",
    fontWeight: 300,
    color: novataNavyDark,
    margin: 0,
    marginBottom: "4px",
    lineHeight: "1.25",
    letterSpacing: "-0.005em",
  },
  subheading: {
    fontFamily: poppins,
    fontSize: "13px",
    fontWeight: 400,
    color: "#5A6B75",
    margin: 0,
    marginBottom: "20px",
    lineHeight: "1.4",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "16px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  sectionLabel: {
    fontFamily: poppins,
    fontSize: "12px",
    fontWeight: 500,
    color: "#5A6B75",
    margin: 0,
    marginBottom: "8px",
    lineHeight: "1.3",
  },
  dropdown: {
    width: "100%",
    minWidth: 0,
    fontFamily: poppins,
  },
  dropdownListbox: {
    maxHeight: "240px",
    fontFamily: poppins,
  },
  emptyState: {
    fontFamily: poppins,
    fontSize: "13px",
    color: "#5A6B75",
    textAlign: "center",
    padding: "16px 8px",
  },
  pendingState: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 0",
  },
  errorText: {
    fontFamily: poppins,
    fontSize: "13px",
    color: "#B3261E",
    margin: 0,
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "16px 24px 24px 24px",
    ...shorthands.borderTop("1px", "solid", "#EEF1F3"),
    backgroundColor: "#ffffff",
  },
  switchButton: {
    minWidth: "120px",
    height: "40px",
    fontFamily: poppins,
    fontWeight: 600,
    fontSize: "14px",
    color: novataNavyDark,
    backgroundColor: novataLime,
    ...shorthands.border("1px", "solid", novataLime),
    ...shorthands.borderRadius("4px"),
    transition: "background-color 120ms ease, border-color 120ms ease",
    "&:hover": {
      backgroundColor: novataLimeHover,
      ...shorthands.borderColor(novataLimeHover),
      color: novataNavyDark,
    },
    "&:hover:active": {
      backgroundColor: novataLimeHover,
      ...shorthands.borderColor(novataLimeHover),
      color: novataNavyDark,
    },
    "&:disabled, &[disabled]": {
      backgroundColor: "#E8EFC4",
      ...shorthands.borderColor("#E8EFC4"),
      color: "#7A8A4F",
      cursor: "not-allowed",
    },
  },
});
